import { createAsyncThunk } from '@reduxjs/toolkit';

import { d2cRestaurantClient } from '../shared/clients';
import { addUserToEulaMessageAcknowledgement, getEulaAcknowledgement, getEulaMessageText } from './apis';
import {
  locationSummaryResponseToLocationSummary,
  restaurantSearchResponseToLocationResult,
} from './transforms';

export const getUserLocations = createAsyncThunk(
  'user/getUserLocations',
  async (payload: { locationNumbers: string[] }) => {
    const response = await d2cRestaurantClient.restaurantSearch(payload);
    return {
      locations: response.restaurants.map((restaurant) =>
        restaurantSearchResponseToLocationResult.parse(restaurant),
      ),
    };
  },
);

export const lookupSingleLocation = createAsyncThunk(
  'user/lookupSingleLocation',
  async (payload: { locationNumber: string }) => {
    const response = await d2cRestaurantClient.restaurantSearch({
      locationNumbers: [payload.locationNumber],
    });
    return {
      locations: response.restaurants.map((restaurant) =>
        restaurantSearchResponseToLocationResult.parse(restaurant),
      ),
    };
  },
);

export const addUserToAcknowledgement = createAsyncThunk('user/addUserToAcknowledgement', async () => {
  await addUserToEulaMessageAcknowledgement();
});

export const getStoreNamesAndNumbers = createAsyncThunk('user/getStoreNamesAndNumbers', async () => {
  const response = await d2cRestaurantClient.locationSummary({});
  return {
    storeNamesAndNumbers: response.locationSummaries.map((summary) =>
      locationSummaryResponseToLocationSummary.parse(summary),
    ),
  };
});

export const checkEulaMessageOnLoad = createAsyncThunk('user/checkEulaMessageOnLoad', async () => {
  const acknowledged = await getEulaAcknowledgement();
  return { acknowledged };
});

export const getEulaMessage = createAsyncThunk('user/getEulaMessage', async () => {
  const text = await getEulaMessageText();
  return { text };
});
